import { render } from "./AdminHome.vue?vue&type=template&id=ee775c64&ts=true"
import script from "./AdminHome.vue?vue&type=script&lang=ts"
export * from "./AdminHome.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__